import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Button, Col} from "reactstrap";
import {Link, Redirect} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";
import get from 'lodash/get';

import {renderErrorsAsHTML} from "../../../Components/utils";
import {clearErrors} from "../../../actions/Connect";
import {CHARGEBEE_ADDON_WHATSAPP_WEB_INSTANCE, CONTACT_SALES_REQUEST_TYPE_WA_TRIAL} from "../../../constants";
import {chargebeeGenerateHostedPage, contactSalesRequest} from "../../../thunks/Billing";


const WhatsApp = (
    {
        activeShop,
        billingConfig,
        errors,
        isSendingHostedPageRequest,
        isSendingContactSalesRequest,

        clearErrors,
        chargebeeGenerateHostedPage,
        contactSalesRequest,
    }
) => {
    const {t, i18n} = useTranslation();

    const [redirectTo, setRedirectTo] = useState(undefined);

    // ComponentDidMount
    useEffect(() => {
        clearErrors();
    }, []);

    if (redirectTo) {
        return <Redirect to={redirectTo}/>
    }

    const dashboardUrl = `/${activeShop.id}/dashboard`;
    const tariff = get(billingConfig, 'tariff');

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        <div className="h5 modal-title text-center pb-2">
                            <h4 className="my-4">
                                <div>
                                    {t('connect_card.wa.title', 'Connect WhatsApp')}
                                </div>
                            </h4>
                        </div>

                        <Trans t={t} i18nKey='connect_card.wa.instruction_text'>
                            <ol>
                                <li>Для работы WhatsApp-канала вам потребуется смартфон с отдельным аккаунтом WhatsApp.</li>
                                <li>Смартфон станет сервером, через который будет работать WhatsApp-бот</li>
                                <li>Перед подключением аккаунта WhatsApp пожалуйста, удалите все чаты в аккаунте</li>
                                <li>В случае отключения смартфона от сети интернет бот не будет получать сообщения и не будет отвечать на них</li>
                            </ol>
                        </Trans>
                        <div className="text-center mt-5 mb-4">
                            {/*<small className='text-secondary'>*/}
                            {/*    {t('connect_card.common.need_pro_caption', 'Available for PRO plan users only')}*/}
                            {/*</small>*/}
                            {/*<br/>*/}
                            {/*<Button color='primary'*/}
                            {/*        className='btn-wide btn-lg font-size-md mt-3'*/}
                            {/*        disabled={isSendingHostedPageRequest}*/}
                            {/*        onClick={() => chargebeeGenerateHostedPage(*/}
                            {/*            CHARGEBEE_ADDON_WHATSAPP_WEB_INSTANCE,*/}
                            {/*            (hosted_page) => {*/}
                            {/*                const chargebeeInstance = window.Chargebee.getInstance();*/}
                            {/*                chargebeeInstance.openCheckout({*/}
                            {/*                        hostedPage: () => new Promise((resolve, reject) => {*/}
                            {/*                            resolve(hosted_page);*/}
                            {/*                        }),*/}
                            {/*                        success: function (hostedPageId) {*/}
                            {/*                        }*/}
                            {/*                    }*/}
                            {/*                );*/}
                            {/*            }*/}
                            {/*        )}*/}
                            {/*>*/}
                            {/*    <Trans t={t} i18nKey='connect_card.wa.pay_now_button'>*/}
                            {/*        Connect now*/}
                            {/*        <br/>*/}
                            {/*        <small>(and upgrade to Pro)</small>*/}
                            {/*    </Trans>*/}
                            {/*</Button>*/}
                            {/*<br/>*/}
                            <Button color='primary'
                                    className='btn-wide btn-lg font-size-md mt-3'
                                    disabled={isSendingContactSalesRequest}
                                    onClick={() => contactSalesRequest(CONTACT_SALES_REQUEST_TYPE_WA_TRIAL)}
                            >
                                <Trans t={t} i18nKey='connect_card.wa.wa_trial_request_button'>
                                    Request free trial instance
                                    <br/>
                                      <small>(to start free 3-days trial)</small>
                                </Trans>
                            </Button>
                        </div>
                        <div className="text-center">
                            {renderErrorsAsHTML(errors)}
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <Link to={dashboardUrl} className="btn-lg btn btn-link">
                            {t('connect_bot.common.back_to_bot_list', 'Back to bots list')}
                        </Link>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    errors: state.Connect.errors,
    billingConfig: state.Billing.billingConfig,
    isSendingHostedPageRequest: state.Billing.isSendingHostedPageRequest,
    isSendingContactSalesRequest: state.Billing.isSendingContactSalesRequest,
});

const mapDispatchToProps = dispatch => ({
    clearErrors: () => dispatch(clearErrors()),
    chargebeeGenerateHostedPage: (addon, callback) => dispatch(chargebeeGenerateHostedPage(addon, callback)),
    contactSalesRequest: (request_type, callback) => dispatch(contactSalesRequest(request_type, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WhatsApp);
